import React, { ReactNode, useLayoutEffect, useState } from 'react';
import { useWhichEnd } from '@mail/m-hooks';
interface IRedirectToMobile {
    children: ReactNode[]
}

const RedirectToMobile: React.FC<IRedirectToMobile> = ({ children }) => {
    const [showPage, setShowPage] = useState<boolean>(false);
    const whichEnd = useWhichEnd();
    const handleRedirect = () => {
        const url = window.location.href;
        if (url.indexOf('index.html') > -1) {
            window.location.href = url.replace('index.html', 'h5.html');
        } else {
            window.location.href = url.replace('accounts-repair/', 'accounts-repair/h5.html')
        }
    }
    useLayoutEffect(() => {
        if (!!whichEnd.h5 && window.location.href.indexOf('h5.html') === -1) {
            // 移动端访问了pc端的页面时，进行跳转（应对短信的场景，后端只能写死pc链接，注意pc和h5页面不是完全一一对应的）
            if (
                window.location.hash.indexOf('inquire') > -1 || 
                window.location.hash.indexOf('safePhoneBind') > -1 ||
                window.location.hash.indexOf('addressVerify') > -1
            ) {
                handleRedirect();
            } else {
                setShowPage(true);
            }
        } else {
            setShowPage(true);
        }
    }, [whichEnd])
    return (
        <>
            { showPage ? children : null}
        </>
    )
}

export default RedirectToMobile;
